module.exports = __webpack_public_path__ + "static/media/mensStyling.b2e4bfaf.png";